import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './MultiLangEdit.html?raw';
import lang from 'dojo/_base/lang';

import Edit from '../Edit/Edit';
import TranslationsForm from './TranslationsForm/TranslationsForm';
import "./TranslationsForm/TranslationsForm"
import { CountryCode2, Language, PitLanguageSuffix, PitLanguageMap, PitLanguageSuffixes } from "./TranslationsForm/TranslationsFormTypes";
import { AccessibilityLabelsHelper } from "../../../more/Helpers";


interface translatedAttribute extends langDict{
    current: string;
}

interface langDict {
    [key: string]: string
}

interface objectWithMultilang<T> extends Object {
    __multilang: {
        [x: string]: translatedAttribute
    } & T & Object
}
class MultiLangEdit<T> extends compose(Edit) {
    templateString: any = template;

    private hasOpenForm: boolean;

    //private btnAutoTranslate: HTMLElement;
    //private selectInfoContainer: HTMLElement;
    private iconTranslationWarning: HTMLElement;
    private btnLanguages: HTMLElement;

    //private _multilangValue: Object & translatedAttribute = null; 
    //Maybe define type for an object containing all three and pass that as prop to widget?
    private commonLanguages: Array<Language> = null;//["D", "E"];
    private availableLanguages: Array<Language> = null;//["D", "E"];
    private mandatoryLanguages: Array<Language> = null;
    private attributeName: string;

    private _currentLanguage: Language;
    private _uiLanguage: Language; // URSPRÜNGLICHE Sprache laut UI! So kommts dann auch aus pit


    //private translationsForm: TranslationsForm;

    //private _enableAutoTranslate: boolean = false;
    //private _autoTranslateActive: boolean = false;


    //setAttributeName(attributeName: string): void {
    //    this.attributeName = attributeName;
    //}

    //getAttributeName(): string {
    //    return this.attributeName;
    //}

    /**
     * Neuen Wert setzen oder initialen
     * @param newValue
     * @param suppressChangeEvent
     */

    setEmptyValue(attributeName) {
        this.setValue({ entity: {} as any, targetAttribute: attributeName }, true);
    }

    //enableAutoTranslate(bEnable: boolean = true, setActive: boolean = true) {
    //    this._enableAutoTranslate = bEnable !== false;


    //    this.hideNode(this.btnAutoTranslate, !this._enableAutoTranslate);
    //}

    setAllLanguagesMandatory() {
        this.mandatoryLanguages = lang.clone(this.availableLanguages);
        if (this.mandatoryLanguages?.length) {
            this.setMandatory(true);
        }
    }
    setCommonDataLanguagesMandatory() {
        this.mandatoryLanguages = lang.clone(this.commonLanguages);
        if (this.mandatoryLanguages?.length) {
            this.setMandatory(true);
        }
    }
    setMandatoryLanguages(languages: Array<Language>) {

        let langArray: Array<Language> = [];
        if (languages?.length) {
            for (let language of languages) {
                let suffix = this.getPitSuffixFromLanguage(language);
                if (suffix) langArray.push(language);
            }
        }

        this.mandatoryLanguages = langArray;

        if (langArray.length > 0) {
            this.setMandatory(true);
        }

    }

    setMandatory(bMandatory: boolean) {

        if (bMandatory === false) this.mandatoryLanguages = [];
        if (!this.mandatoryLanguages && bMandatory !== false) this.setCommonDataLanguagesMandatory();

        let self = this as any;
        super.setMandatory.apply(this, arguments as any);        
    }

    protected swapInputs() {
        if (this.isMultiline) {

        }

        let self = this as any;
        super.swapInputs.apply(this, arguments as any);

        this.UiModder.domClass.remove(this.inputNode, "border");
        this.UiModder.domClass.add(this.inputNode, "noBorder w3-border-0");
    }

    /**
     * Allgemein nutzbare Hilfsfunktion: Übersetzt eine Sprache (D, E, NL) in das zugehörige pit-Sprachsuffix (_D, _E, _NL)
     */
    getPitSuffixFromLanguage(language: Language): PitLanguageSuffix {
        if (!language) return null;

        for (let entry in PitLanguageMap) {
            if (PitLanguageMap[entry] == language) {
                return entry as any;
            }
        }

        return null;
    }

    /**
     * Allgemein nutzbare Hilfsfunktion: Übersetzt eine pit-Sprache (_D, _E, _NL) in den normalen Sprachenkatalog (D, E, NL)
     */
    getLanguageFromPitSuffix(pitlanguage: PitLanguageSuffix): Language {
        if (!pitlanguage) return null;

        return PitLanguageMap[pitlanguage];

       
    }

    
    private _onTranslatedValue(language: Language, translatedValue: string) {
        this.setValueOnLanguage(translatedValue, language);
    }

    setValueOnLanguage(newValue: string, language?: Language, bSuppressChangeEvent?: boolean) {
        if (!language) language = this._currentLanguage;

        if (!language) return;

        let internalValue = this._value as Object & translatedAttribute;

        if (!internalValue) {
            // ansonsten bauen wir uns halt ein leeres Objekt
            internalValue = this._createEmptyDummy();
        } else {
            internalValue = lang.clone(internalValue);
        }



        if (language == this._uiLanguage) {
            internalValue["current"] = newValue;
        }

        let suffix = this.getPitSuffixFromLanguage(language);
        if (suffix) internalValue[suffix] = newValue ? newValue : "";

        this._setNewInternalValue(internalValue, bSuppressChangeEvent);

    }

    private _createEmptyDummy(): Object & translatedAttribute {
        let dummy = {
            current: ""
        }

        // erweitern um die verfügbaren Languages:
        for (let language of this.availableLanguages) {
            // Suffix aus Mapping lesen
            let suffix = this.getPitSuffixFromLanguage(language);
            dummy[suffix] = "";
        }

        return dummy;
    }

    setValue(newValue: { entity: T, targetAttribute: string } | string, suppressChangeEvent: boolean = false): void {

        let stringValue = null;
        let internalValue = this._value as Object & translatedAttribute;
        let attributeProperty = this.attributeName;


        if (newValue == null || typeof (newValue) == "undefined") {
            // das passiert explizit. d.h. wenn das Input gelöscht wird, kommen wir hier NICHT her, weil dann ist der Wert ein Leerstring.
            this._value = null;
            this._setNewInternalValue(null, suppressChangeEvent);

        }


        else if (typeof (newValue) == "string") {

            // falls initiale Registrierung vorhanden (Attributname bekannt), sollte der Stringwert einfach aufs current gesetzt werden.

            this.setValueOnLanguage(newValue, null, suppressChangeEvent);

            //if (this.isHtmlEdit) {
            //    let self: any = this;
            //    self.inherited(arguments);
            //}


            //if (internalValue) {
                // es ändert sich der Current-Wert, oder was halt sonst als Sprache eingestellt ist

                //if (this._enableAutoTranslate) {
                //    // alle anderen Werte translaten!
                //    let sourceLang = this._currentLanguage;
                //    let form = new TranslationsForm(); // eine Translationsform ausleihen, die den Translate-Request für mich durchführt. braucht kein Setup und nichts sonst, Inputs usw interessieren uns hier nicht.

                //    for (let language of this.commonLanguages) {
                //        let suffix = this.getPitSuffixFromLanguage(language);

                //        if (sourceLang != language) {
                //            if (!newValue) {
                //                this.setValueOnLanguage("", language);
                //            } else {
                //                form.fetchTranslation(sourceLang, newValue, language, lang.hitch(this, this._onTranslatedValue, language));
                //            }
                //        }
                //    }
                //} else {
                //this.setValueOnLanguage(newValue);
                //}

        //    } 
        }

        // es ist ein Objekt, das das entity und den Attributnamen enthält.
        else {

            if (newValue?.targetAttribute) this.setAttributeName(newValue.targetAttribute);
            attributeProperty = this.attributeName;

            if (!internalValue) {
                // ansonsten bauen wir uns halt ein leeres Objekt
                internalValue = this._createEmptyDummy();
            } else {
                internalValue = lang.clone(internalValue);
            }


            let entityAsObject = newValue?.entity as Object;
            if (!entityAsObject) {

            } else {
                // wenn das Entity das gesuchte Property selber hat, dann den Wert auf jeden Fall mal vormerken
                // das muss im Zweifel der "current"-Wert sein
                if (entityAsObject.hasOwnProperty(attributeProperty)) {
                    stringValue = newValue.entity[attributeProperty];
                }

                // Übersetzungen suchen unter __multilang.<targetAttribute>
                if (entityAsObject.hasOwnProperty("__multilang")) {
                    let multilangObject = entityAsObject["__multilang"] as Object;

                    if (multilangObject.hasOwnProperty(attributeProperty)) {
                        multilangObject = multilangObject[attributeProperty];

                        // jetzt sind wir auf __multilang.attribut, von da gehts weiter mit den Sprachen und current:

                        if (multilangObject["current"]) stringValue = multilangObject["current"];

                        for (let language of this.availableLanguages) {
                            let translatedValue = "";
                            let suffix = this.getPitSuffixFromLanguage(language);

                            if (multilangObject.hasOwnProperty(suffix)) {
                                translatedValue = multilangObject[suffix];
                            }

                            internalValue[suffix] = translatedValue;
                        }

                        internalValue["current"] = stringValue;
                    }
                }
            }

            this._setNewInternalValue(internalValue, suppressChangeEvent);
        }

    }

    private _setNewInternalValue(newInternalValue: Object & translatedAttribute, suppressChangeEvent?: boolean) {
        
        
        let actuallyChanged = JSON.stringify(this._value) != JSON.stringify(newInternalValue);

        this._value = newInternalValue ? lang.clone(newInternalValue) : null; // lieber klonen, damit wir keinen byref-Schas haben...
        if (actuallyChanged) {
            this.setInputValue();

            if (!suppressChangeEvent) {
                this.__delayValueChangeEmit();
            }
        }
        //this.setInputValue();
        this.validateInput();

        // zählen wie viele ausgefüllt sind:
        let count = 0;
        if (newInternalValue) {
            for (let language of this.commonLanguages) {
                let value = this.getValueOfLanguage(language);
                if (!!value) count++;
            }
        }
        this.drawSelectInfoLabel(this.commonLanguages.length, count, true);
    }

    getValueOfLanguage(targetLanguage?: Language): string {
        if (!targetLanguage) targetLanguage = this._currentLanguage;

        if (!targetLanguage) return null;

        if (this.availableLanguages.indexOf(targetLanguage) == -1) return null;

        if (!this._value) return null;

        let suffix = this.getPitSuffixFromLanguage(targetLanguage);
        if (suffix) {
            if (this._value[suffix]) return this._value[suffix];
        }

        return null;
    }

    /**
     * Schreibt den aktuellen Wert des Edits mit allen Übersetzungen auf das Entity-Objekt (übergebenes Objekt wird manipuliert!)
     * Das MultiLangEdit muss den den Zielattributnamen kennen (setAttributeName) oder er wird optional hier mitgegeben.
     * Bei Erfolg steht die "aktuelle Sprache" als Property direkt auf entity, sowie alle Übersetzungen in einem eigenen _multilang-Property
     * @param entity
     */
    getValueOntoEntity(entity: T, targetAttributeName?: string): void {
        if (!entity) entity = {} as T;
        let value = this.getValue() as Object & translatedAttribute;

        if (value) value = lang.clone(value);

        if (!targetAttributeName) targetAttributeName = this.attributeName;
        if (!targetAttributeName) {
            console.warn(this.id + ": cannot write value on entity without attributename!", entity);
            return; // was sollma machen, ohne des gehts ned.
        }

        try {
            let entityObj = entity as Object & T;

            // direkten Attributwert setzen:
            entityObj[targetAttributeName] = value ? value.current : null;

            if (!entityObj.hasOwnProperty("__multilang")) entity["__multilang"] = {};

            entityObj["__multilang"][targetAttributeName] = value;
        } catch (ex) {
            console.error(this.id + ": setting value on entity failed!", value, "targetAttribute: " + targetAttributeName, entity, ex);
        }

    }
    protected customValidation(): boolean {
        if (!this.hasFeature("Multilang/EnableMultiLangEdit")) {
            let data = this._value;
            let result: boolean = false;

            if (data && typeof (data.current) == "string") data = data.current;
            else data = "";

            if (this.pattern && typeof (data) == "string") {
                let testValue = new RegExp(this.pattern);
                result = testValue.test(data);
            } else {
                result = true;
            }

            if (this.isMandatory && (data == undefined || data == "" || data == null)) {

                //this.validationErrorMsgText = window.translations['Generic__mandatory'];
                result = false;

            }
            console.log("Validate", this.pattern, data);
            return result;
        } else {
            let targetLanguage = this._currentLanguage;
            let suffix = this.getPitSuffixFromLanguage(targetLanguage);
            let value: string = null;

            if (suffix) {
                value = this._value?.[suffix];
            } else {
                value = this._value?.current;
            }

            let result: boolean = false;

            if (this.pattern && typeof (value) == "string") {
                let testValue = new RegExp(this.pattern);
                result = testValue.test(value);
            } else {
                result = true;
            }

            if (!this.isMandatory) return result;

            if (this.isMandatory && (value == undefined || value == "" || value == null)) {

                //this.validationErrorMsgText = window.translations['Generic__mandatory'];
                result = false;

            }

            if (this.mandatoryLanguages?.length > 0 && result == true) {
                for (let language of this.mandatoryLanguages) {
                    let suffix = this.getPitSuffixFromLanguage(language);

                    if (suffix) {
                        let translationValue = this._value?.[suffix];

                        if (this.pattern && typeof (translationValue) == "string") {
                            let testValue = new RegExp(this.pattern);
                            result = result && testValue.test(translationValue);
                        } else {
                            result = result && !!translationValue;
                        }
                    }

                    if (!result) return result;
                }
            }

            return result;
        }
    }
    protected setInputValue(): void {
        
        let targetProperty = "current";
        if (this._currentLanguage) {
            let suffix = this.getPitSuffixFromLanguage(this._currentLanguage);

            targetProperty = suffix;
        }

        if (this._value?.hasOwnProperty(targetProperty)) {
            if (!this.isHtmlEdit) {
                this.inputNode.value = this._value[targetProperty];
            } else {
                this.inputNode.innerHTML = this._value[targetProperty];
            }
            
        }
        else {
            this.inputNode.value = "";
        }
    }

    protected getStringValue(): string {
        let targetProperty = "current";
        if (this._currentLanguage) {
            let suffix = this.getPitSuffixFromLanguage(this._currentLanguage);

            targetProperty = suffix;
        }

        if (this._value?.hasOwnProperty(targetProperty)) {
            return this._value[targetProperty];
        }
    }

    protected _onChange_InputNode(): void {
        // jetzt muss das aber wieder seinen Weg ins registrierte Objekt nehmen und mit emit kommuniziert werden

        this.setValue(this.inputNode.value);
        
        //this.emitChangeEvent();

        // es wurde ja nur die aktuelle Sprache angepasst. die anderen Übersetzungen sollten ja ggf. nochmal vom Benutzer geprüft werden!
        this.hideNode(this.iconTranslationWarning, false);

    //    if (this._enableAutoTranslate) {
    //        this.disableNode(this.btnAutoTranslate, false);
    //    }
    }

    private _setLanguagesAttr(availableLanguages: Array<Language>) {
        this._setAvailableLanguagesAttr(availableLanguages);
    }

    //Filter available languages property for not supported languages
    private _setAvailableLanguagesAttr(availableLanguages: Array<Language>, commonLanguages?: Array<Language>): void {
        let possibleCodes = Object.keys(CountryCode2);
        let filteredAllLanguages: Array<Language> = availableLanguages.filter((currentLanguage) => {
            return possibleCodes.indexOf(currentLanguage) !== -1;
        })

        ////FALLBACK:
        //if (filteredAllLanguages.length == 0) filteredAllLanguages = ["D", "E"];

        this.availableLanguages = filteredAllLanguages;

        if (commonLanguages?.length) {
            let filteredCommonLanguages: Array<Language> = commonLanguages.filter((currentLanguage) => {
                return possibleCodes.indexOf(currentLanguage) !== -1;
            })

            this.commonLanguages = filteredCommonLanguages;
        } else {
            this.commonLanguages = lang.clone(this.availableLanguages);
        }

        if (this.commonLanguages.length && this.isMandatory && !this.mandatoryLanguages.length) {
            this.setCommonDataLanguagesMandatory();
        }

        this.disableNode(this.btnLanguages, !this.availableLanguages?.length);
    }

    private _getAvailableLanguagesAttr(): Array<Language> {
        return this.availableLanguages;
    }

    setAttributeName(attributeName: string) {
        this.attributeName = attributeName;
    }
    private _setAttributeNameAttr(attributeName: string): void {
        this.setAttributeName(attributeName);
    }

    private _setHasOpenForm(hasOpenForm: boolean) {
        this.hasOpenForm = hasOpenForm;
    }

    private setupTranslationForm(evt?: MouseEvent): MdsLax<InstanceType<typeof TranslationsForm>> {
        let translationsForm = new TranslationsForm();
        translationsForm.on("open", lang.hitch(this, this._setHasOpenForm, true));
        translationsForm.on("close", lang.hitch(this, this._setHasOpenForm, false));

        translationsForm.setMandatoryLanguages(this.mandatoryLanguages);
        translationsForm.setOptionalLanguages(this.availableLanguages);
        if( translationsForm.setIsHtmlEdit) translationsForm.setIsHtmlEdit(this.isHtmlEdit);
        translationsForm.setupForm(this.getLabel(), this.commonLanguages, this.attributeName, this._value, evt);
        translationsForm.setMultiline(this.isMultiline, this.rows);



        return translationsForm;
    }
    private _onLanguagesClick(e: MouseEvent): void {
        if (!this.hasOpenForm) {
            let translationsForm = this.setupTranslationForm(e);
            translationsForm.on("ok", lang.hitch(this, this._onTranslationsFormResponse, translationsForm));
        }
       }

    private _onClick_AutoTranslate(evt: MouseEvent) {
        
    }

    private _onTranslationsFormResponse(form: MdsLax<InstanceType<typeof TranslationsForm>>): void {
        if (form.getIsDirty()) {
            this.setValue(form.getDataForEntity() as any);
            //Workaround should reimplement setValue to call setInputValue() is not calling by itself
            this.setInputValue();
            this.emitChangeEvent();
        }

        this.hideNode(this.iconTranslationWarning);

        form.destroy();
    }

    protected _setReadonlyStyle(): void {
        super._setReadonlyStyle.apply(this, arguments as any);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        let currentCode = window.currentLanguageCode as Language;
        this._uiLanguage = currentCode;
        this._currentLanguage = currentCode;
        this.mandatoryLanguages = [];


        // ACHTUNG: die commonLanguages könnten auch schon über dojo-props gesetzt worden sein!
        let available = this._getAvailableLanguagesAttr();
        if (!available?.length) {
            let availablelanguages: Array<Language> = [];
            let commonLanguages: Array<Language> = [];

            let dataLangSettings = this.getCustomerSetting("dataLanguages");
            let allLangSettings = this.getCustomerSetting("allLanguages");

            if (!dataLangSettings || dataLangSettings.length === 0) {
                dataLangSettings = ["_D", "_E"];
                this.mandatoryLanguages = ["D"];
            }
            if (!allLangSettings || allLangSettings.length === 0) allLangSettings = ["_D", "_E"];

            if (dataLangSettings?.length && !allLangSettings?.length) {
                allLangSettings = dataLangSettings;
                allLangSettings = null;
            }

            if (dataLangSettings && dataLangSettings.length) {
                for (let suffix of dataLangSettings) {
                    commonLanguages.push(PitLanguageMap[suffix]);
                }

            }

            if (allLangSettings && allLangSettings.length) {
                for (let suffix of allLangSettings) {
                    availablelanguages.push(PitLanguageMap[suffix]);
                }

            }

            this._setAvailableLanguagesAttr(availablelanguages, commonLanguages);
        }

        if (!this.hasFeature("Multilang/EnableMultiLangEdit")) {
            this.hideNode(this.btnLanguages);
            this.hideNode(this.selectInfoContainer);
            this.UiModder.domClass.remove(this.domNode, "multilang");
        }

        AccessibilityLabelsHelper.LabelForInputBind(this.id, this.inputNode, "multilangInput", this.labelNode, true, true);
    }

    postMixInProperties(): void {

        if (this.availableLanguages?.length) {
            if (!this.commonLanguages?.length) {
                this.commonLanguages = lang.clone(this.availableLanguages);
            }
        }
        super.postMixInProperties.apply(this, arguments as any);

    } startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(MultiLangEdit);